/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Bar from "../../Charts/Bar";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { Wrapper } from "../styles/charts-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";
import ReactTooltip from "react-tooltip";

export interface ITimeToSubmissionProps {
  timeToSubmission: {
    months?: Date[];
    values?: number[];
  };
  timeToSubmissionWidgetLoader: boolean;
}

interface ITimeToSubmissionState {
  placementsMadeWidgetLoader: boolean;
}

export class TimeToSubmission extends Component<
  ITimeToSubmissionProps,
  ITimeToSubmissionState
> {
  static propTypes = {
    timeToSubmission: PropTypes.shape({
      months: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      values: PropTypes.arrayOf(PropTypes.number),
    }),
    timeToSubmissionWidgetLoader: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    timeToSubmission: {
      months: [],
      values: [],
    },
  };

  render(): ReactNode {
    const { timeToSubmission, timeToSubmissionWidgetLoader } = this.props;

    const timeToSubmissionOptions = {
      series: [
        {
          name: "Time to Submission",
          data: timeToSubmission.values,
        },
      ],
      options: {
        width: 400,
        height: 350,
        colors: ["#402680"],
        chart: {
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
          formatter: (val: number) => val,
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "11px",
            colors: ["#333"],
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 4,
            borderRadiusApplication: "end",
            dataLabels: {
              position: "bottom",
            },
          },
        },
        xaxis: {
          type: "datetime",
          categories: timeToSubmission.months.map((date) => date.getTime()),
          title: {
            text: "Time",
          },
        },
        yaxis: {
          title: {
            text: "Candidates Submiited",
          },
          min: 0,
          max: Math.max(...timeToSubmission.values, 10),
        },
        // responsive: [
        //   {
        //     breakpoint: 1199,
        //     options: {
        //       chart: {
        //         width: "100%",
        //         height: 330,
        //       },
        //     },
        //   },
        // ],
        tooltip: {
          x: {
            formatter: function (value) {
              const date = new Date(value);
              return date.toLocaleString("default", { month: "short" });
            },
          },
        },
      },
    };

    return (
      <Fragment>
        <Wrapper
          className="animated fadeIn delay-5"
          id="time-to-submission-widget"
        >
          <AnalyticsWidgetLoading
            text="Updating..."
            active={timeToSubmissionWidgetLoader}
          />

          <Bar
            graphOptions={timeToSubmissionOptions}
            dataTestId="time-to-submission-chart"
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="time-to-submission-chart-title"
            data-tip=" Number of days after role posting to receive first candidate submission."
            data-for="time-to-submission-chart-title-tooltip"
          >
            <ReactTooltip
              type="dark"
              aria-haspopup="true"
              id="time-to-submission-chart-title-tooltip"
              className="tooltip-max-width"
            />
            Time to first submission
          </ChartTitle>
        </Wrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    jobPerformanceData: {
      timeToSubmission: {
        months: Date[];
        yourCompany: number[];
      };
    };
    timeToSubmissionWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  timeToSubmission: state.employerAnalytics.jobPerformanceData.timeToSubmission,
  timeToSubmissionWidgetLoader:
    state.employerAnalytics.timeToSubmissionWidgetLoader,
});

export default connect(mapStateToProps, {})(TimeToSubmission);
